// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".allProducts_qlyye{width:100%}.addMoreToYourBundleString_QYsfQ{font-weight:700;font-size:20px;line-height:26px;padding-left:15px;margin-top:5px}", ""]);
// Exports
exports.locals = {
	"allProducts": "allProducts_qlyye",
	"addMoreToYourBundleString": "addMoreToYourBundleString_QYsfQ"
};
module.exports = exports;
